import styled from "styled-components";

export const Wrapper = styled.div`
  position: relative;
  width: 100%;
  background: #ffffff;
  border-radius: 0 0 16px 16px;
  overflow: auto;
`;

export const StyledTable = styled.table`
  width: 100%;
  min-width: max-content;
  border-collapse: collapse;
  table-layout: fixed;
`;

export const Thead = styled.thead`
  background: #f8f9fc;
`;

export const Tbody = styled.tbody``;

export const Tr = styled.tr`
  background: ${(props) => (props.$striped ? "#f4f6fb" : "transparent")};
  cursor: ${(props) => (props.onClick ? "pointer" : "default")};
`;

export const Th = styled.th`
  text-align: left;
  padding: 20px;
  font-size: 14px;
  font-weight: 500;
  color: #293142;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  border-bottom: 1px solid #e6e9ef;
  width: ${(props) => (props.$width ? `${props.$width}px` : "auto")};
  ${(props) =>
    props.$sticky === "right" &&
    `
      position: sticky;
      right: 0;
      z-index: 1;
      background: #f4f6fb;
      border-left: 1px solid rgba(242, 244, 247, 1);
      box-shadow: -2px 0px 4px rgba(28, 28, 28, 0.04);
    `}
`;

export const Td = styled.td`
  padding: 20px;
  font-size: 14px;
  color: #293142;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  border-bottom: 1px solid #e6e9ef;
  height: 80px;
  box-sizing: border-box;
  width: ${(props) => (props.$width ? `${props.$width}px` : "auto")};
  ${(props) =>
    props.$sticky === "right" &&
    `
      position: sticky;
      right: 0;
      z-index: 1;
      background: #ffffff;
      border-left: 1px solid rgba(242, 244, 247, 1);
      border-bottom: 1px solid rgba(242, 244, 247, 1);
      box-shadow: -2px 0px 4px rgba(28, 28, 28, 0.04);
    `}
`;

export const EmptyState = styled.div`
  padding: 48px 20px;
  text-align: center;
  color: #767c8f;
  font-size: 14px;
`;

export const LoadingOverlay = styled.div`
  position: absolute;
  inset: 0;
  background: rgba(255, 255, 255, 0.6);
`;

export const PaginationBar = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  padding: 16px 24px;
  border-top: 1px solid #e6e9ef;
`;

export const ResultsText = styled.p`
  margin: 0;
  font-size: 14px;
  color: #767c8f;
`;

export const ResultsCount = styled.span`
  font-weight: 500;
  color: #111827;
`;

export const PaginationControls = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
`;

export const PageButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  border-radius: 8px;
  border: 1px solid #e6e9ef;
  background: ${(props) => (props.$active ? "#ef4f5f" : "#ffffff")};
  color: ${(props) => (props.$active ? "#ffffff" : "#0a0a0a")};
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;

  &:disabled {
    opacity: 0.4;
    cursor: not-allowed;
  }
`;
